import { Assets } from 'pixi.js';
import manifest from './manifest.json';

export async function initAssets() {
  await Assets.init({
    manifest,
    basePath: '/assets/packed'   // <= must match your .assetpack.js output (./public/assets)
  });
}

export const loadBootBundles = (onProgress?: (p:number)=>void) =>
  Assets.loadBundle(['default','gui'], onProgress);

export const loadGameBundles = () =>
  Assets.backgroundLoad(['units', 'drops', 'heroes', 'buildings']);
